import React, { useState } from "react";
import useEditTraining from "../hooks/useEditTraining";
import useUploadFiles from "../../../services/hooks/useUploadFiles";

// components
import Upload from "../../../component/modals/upload";
import TextBox from "../../../component/element/forms/TextBox";
import TextInput from "../../../component/element/forms/TextInput";
import SelectDate from "../../../component/element/forms/SelectDateTime";
import SelectOption from "../../../component/element/forms/SelectOption";

// state
import { useAppDispatch, useAppSelector } from "../../../store";
import { get_training, edit } from "../../../services/apis/training";
import { getCountry, getState } from "../../../services/apis/country";
import Button from "../../../component/element/forms/Button";
import { useNavigate, useParams } from "react-router-dom";
// import { loading } from "../../../store/slices/loading";

// type IEditTraining = {
//   id: string;
//   onHandler: () => void;
// };

const EditTraining = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [imgPath, setImgPath] = useState("");

  const states = useAppSelector(({ country }) => country.states);
  const countries = useAppSelector(({ country }) => country.countries);
  // const loading = useAppSelector(({ loading }) => loading.loading);
  const { data, dataSet, errorSet, onValidate } = useEditTraining();

  const { loader, uploadFile, deleteFiles } = useUploadFiles();

  const handleOk = () => {
    const validate = onValidate();
    if (!validate) return;

    edit(data, dispatch);
    navigate(-1);
  };

  const onLoad = React.useCallback(() => {
    if (id) {
      get_training(dispatch, id);
      getCountry(dispatch);
    }
  }, [dispatch, id]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="space-y-6 bg-white p-6 rounded-xl shadow-md">
      <div className="">
        {/* <img src={image} alt="Edit Training" className="w-11 h-auto" /> */}
      </div>

      <Upload
        title="Upload Image"
        label="JPG & PNG"
        name="image"
        loading={loader}
        status=""
        completed={!!data.image}
        imgPreview={data.image} // This should show the existing image
        onChange={async (fileOrFiles) => {
          const paths = await uploadFile(fileOrFiles as File, "trainings");
          if (paths.length > 0) {
            const img_path = paths[0].base_url + "/" + paths[0].path;
            dataSet((prev) => ({ ...prev, image: img_path }));
            errorSet((prev) => ({ ...prev, image: "" }));
            setImgPath(paths[0].path);
          }
        }}
        onDelete={async () => {
          if (imgPath) {
            const res = await deleteFiles(imgPath);
            if (res) {
              dataSet((prev) => ({ ...prev, image: "" }));
              errorSet((prev) => ({ ...prev, image: "" }));
            }
          }
        }}
      />

      <TextInput
        label="Title"
        name="name"
        placeholder="Title"
        value={data.name}
        type="text"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const { value, name } = e.target;
          dataSet((prev) => ({ ...prev, [name]: value }));
          errorSet((prev) => ({ ...prev, [name]: "" }));
        }}
      />

      <TextInput
        label="Address"
        name="address"
        placeholder="Address"
        value={data.address}
        type="text"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const { value, name } = e.target;
          dataSet((prev) => ({ ...prev, [name]: value }));
          errorSet((prev) => ({ ...prev, [name]: "" }));
        }}
      />

      <div className="grid grid-cols-2 gap-6">
        <TextInput
          label="Link"
          name="link"
          placeholder="Link"
          value={data.link}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const { value, name } = e.target;
            dataSet((prev) => ({ ...prev, [name]: value }));
            errorSet((prev) => ({ ...prev, [name]: "" }));
          }}
        />

        <TextInput
          label="Amount"
          name="amount"
          placeholder="Amount"
          value={data.amount}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const { value, name } = e.target;
            dataSet((prev) => ({ ...prev, [name]: value }));
            errorSet((prev) => ({ ...prev, [name]: "" }));
          }}
        />

        <TextInput
          label="Duration"
          name="duration"
          placeholder="Duration"
          value={data.duration}
          type="text"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const { value, name } = e.target;
            dataSet((prev) => ({ ...prev, [name]: value }));
            errorSet((prev) => ({ ...prev, [name]: "" }));
          }}
        />

        <SelectDate
          label="Date"
          placeholder="Date"
          onChange={(e) => {
            dataSet((prev) => ({ ...prev, date: e }));
            errorSet((prev) => ({ ...prev, date: "" }));
          }}
        />
        <SelectOption
          items={countries}
          label="Country"
          placeholder="Country"
          onChange={(e) => {
            dataSet((prev) => ({ ...prev, country_id: e }));
            errorSet((prev) => ({ ...prev, country_id: "" }));
            getState(e, dispatch);
          }}
        />

        <SelectOption
          items={states}
          label="State"
          placeholder="State"
          onChange={(e) => {
            dataSet((prev) => ({ ...prev, state_id: e }));
            errorSet((prev) => ({ ...prev, state_id: "" }));
          }}
        />
      </div>

      <div>
        <TextBox
          name="body"
          placeholder="Description"
          value={data.body}
          onChange={(name, value) => {
            dataSet((prev) => ({ ...prev, body: value }));
            errorSet((prev) => ({ ...prev, body: "" }));
          }}
        />
      </div>

      <Button
        title="Update"
        type="submit"
        // loading={loading}
        onClick={handleOk}
        className="text-white"
      />
    </div>
  );
};

export default EditTraining;
